import React from 'react';

import thankyouimg from '../assets/img/thankyou.jpg';
import logo from '../assets/img/logo_4.png';
import sandenLogo from '../assets/img/sanden_logo.png';
import useStyles from '../styles/styles';

const PeThankyouPage: React.FC = () => {
  const classes = useStyles();

  return <div className={classes.PeThankYouPage_control}>
    <img src={thankyouimg} alt="thank you" style={{width: '70%'}}/>
    <p className={classes.thankyou}>Thank you</p>
    <p className={classes.text}>Thank you for submitting your Battery quote, please check your email and SMS if you requested an SMS copy. Any questions we would be more than happy to assist. Regards, The Pure Electric Team</p>
    <div className={classes.logo}>
      <img src={logo} alt="logo" className={classes.iconPartner} />
      {/* <img src={sandenLogo} alt="sandenLogo" className={classes.iconPartner} /> */}
    </div>
  </div>
}

export default PeThankyouPage;